import { toDateString, toSetString } from "@/helpers/converters";
import { keepOnlyFieldQueryStrings, omitInvalidFieldSort, toByKey, toDataIndex, toQs2Label } from "@/helpers/field";

export const CASE_PHASES = [
  "Case Closed",
  "Interim Phase",
  "Oral Phase",
  "Written Phase"
];

export const DEFAULT_ACTION_APPLICATION_TYPES = [
  "Provisionalmeasures",
  "Counter claim for revocation",
  "Infringement",
  "Revocation",
  "Appeal"
];

export const FIELDS = [
  { key: "caseNumber", field: "case_number", qs: "case_number", label: "Case", placeholder: "e.g. UPC_CFI_802/2025", sorter: true },
  { key: "patentNumber", field: "patent_number", qs: "patent_number", label: "Patent", placeholder: "e.g. EP-2185994-A1", sorter: true },
  { key: "casePhase", field: "case_phase", qs: "case_phase", label: "Phase", placeholder: "e.g. Closed Phase", sorter: true },
  { key: "filingDate", field: "filing_date", qs: "filing_date", label: "Filing Date", render: toDateString, sorter: true },
  { key: "actionApplicationType", field: "action_application_type", qs: "action_application_type", label: "Action", placeholder: "e.g. Revocation" },
  { key: "respondent", field: "respondent", qs: "respondent", label: "Respondent", placeholder: "e.g. Robert Bosch GMBH", render: toSetString },
  { key: "claimant", field: "claimant", qs: "claimant", label: "Claimant", placeholder: "e.g. Sanofi-Aventis Deutschland GmbH", render: toSetString },
  { key: "representatives", field: "representatives", qs: "representatives", label: "Representatives", placeholder: "e.g. Daniel Wise", render: toSetString },
  { key: "judges", field: "judges", qs: "judges", label: "Judges", placeholder: "e.g. Paolo Catallozzi", render: toSetString },
  { key: "fullText", field: "documents.full_text", qs: "documents.full_text", label: "Full Text", placeholder: "e.g. central division" },
  { key: null, field: "sort", qs: "sort", label: "Sort" }
];

export const byKey = toByKey(FIELDS);

export const qs2label = toQs2Label(FIELDS);

export const keepOnlyQueryStrings = query => keepOnlyFieldQueryStrings(FIELDS, query);

export const omitInvalidSort = query => omitInvalidFieldSort(FIELDS, query);

export { toDataIndex };